import { render, staticRenderFns } from "./bsite_sus.vue?vue&type=template&id=3caa1ad1&scoped=true"
import script from "./bsite_sus.vue?vue&type=script&lang=js"
export * from "./bsite_sus.vue?vue&type=script&lang=js"
import style0 from "./bsite_sus.vue?vue&type=style&index=0&id=3caa1ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caa1ad1",
  null
  
)

export default component.exports